import { ErrorHandler, Injectable, PLATFORM_ID, inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private platformId = inject(PLATFORM_ID);

  handleError(error: any): void {
    const message = error?.message || "";
    const isChunkError =
      /Loading chunk [\d]+ failed/.test(message) ||
      /Failed to fetch dynamically imported module/.test(message);

    if (isChunkError && isPlatformBrowser(this.platformId)) {
      // Reload once to get fresh chunk references — guard against infinite loop
      const key = "chunk_error_reload";
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return;
      }
      // Clear the flag after a short delay so future deploys can trigger a reload
      setTimeout(() => sessionStorage.removeItem(key), 10_000);
    }

    console.error(error);
  }
}
